import React, { FunctionComponent } from 'react'
import { Field } from 'redux-form'

import { SelectField } from '../../../components/inputs'
import { Vehicle } from '../../../core/types'

export interface Props {
  vehicle: Vehicle
}

const TrimLevel: FunctionComponent<Props> = ({ vehicle }) => {
  if (!vehicle.trims) {
    return null
  }

  const trimLevelOptions = vehicle.trims.map((trim) => (
    <option key={trim.id} value={trim.id}>
      {trim.series}
    </option>
  ))

  return (
    <Field<any> // TODO-TS
      label="Trim level"
      name="selected_trim_id"
      component={SelectField}
      aria-required="true"
    >
      {trimLevelOptions}
    </Field>
  )
}

export default TrimLevel
